module.exports = __webpack_public_path__ + "static/media/mlh.0457acc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/mlh.svg
// module id = 358
// module chunks = 0